import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Button from '../../button/Button';
import { hideModal, listProjectUsers } from '../../../redux/actions';
import text from '../../../text';
import routes from '../../../routes/constants';
import Loading from '../../loading/Loading';
import List from '../../list/List';
import Icon from '../../icon/Icon';
import TextDivider from '../../text/TextDivider';
import { formatDate } from '../../../utilities/date';
import { getUserMembership } from '../../../utilities/user';
export var PROJECT_TRIAL_MEMBERS_SUCCESS_MODAL = 'PROJECT_TRIAL_MEMBERS_SUCCESS_MODAL';
var ProjectTrialMembersSuccessModal = function(param) {
    var show = param.show, projectId = param.projectId;
    var _projectUsers_projectId, _getUserMembership, _projectUsers_projectId1, _projectUsers_projectId2;
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return {
            projectUsers: state.project.projectUsers,
            currentUser: state.profileReducer.userProfile
        };
    }), projectUsers = _useSelector.projectUsers, currentUser = _useSelector.currentUser;
    var history = useHistory();
    var onHide = function() {
        return dispatch(hideModal(PROJECT_TRIAL_MEMBERS_SUCCESS_MODAL));
    };
    useEffect(function() {
        var _projectUsers_projectId;
        if (projectId && !projectUsers[projectId] && !((_projectUsers_projectId = projectUsers[projectId]) === null || _projectUsers_projectId === void 0 ? void 0 : _projectUsers_projectId.isLoading)) {
            dispatch(listProjectUsers(projectId));
        }
    }, [
        projectId
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        className: "ProjectTrialMembersSuccessModal",
        show: show,
        onHide: onHide
    }, !((_projectUsers_projectId = projectUsers[projectId]) === null || _projectUsers_projectId === void 0 ? void 0 : _projectUsers_projectId.isLoading) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal.Header, null, /*#__PURE__*/ React.createElement("div", {
        className: "w-100 center-content flex-column"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-tick_filled"
    }), /*#__PURE__*/ React.createElement("h3", {
        className: "m-4"
    }, text('projectTrialSuccessModalHeader')), /*#__PURE__*/ React.createElement(List, {
        className: "m-auto",
        isPaddingless: true,
        isBorderless: true
    }, /*#__PURE__*/ React.createElement(List.Item, {
        isColonAppended: true,
        description: text('endDateTrial'),
        value: formatDate((_getUserMembership = getUserMembership(currentUser)) === null || _getUserMembership === void 0 ? void 0 : _getUserMembership.end_date)
    })))), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement(TextDivider, {
        isComplete: true,
        isSecondary: true
    }), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('usersHaveAccessToPlatform')), !((_projectUsers_projectId1 = projectUsers[projectId]) === null || _projectUsers_projectId1 === void 0 ? void 0 : _projectUsers_projectId1.isLoading) ? /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        isBorderless: true,
        className: "px-4"
    }, (_projectUsers_projectId2 = projectUsers[projectId]) === null || _projectUsers_projectId2 === void 0 ? void 0 : _projectUsers_projectId2.users.map(function(item, i) {
        return /*#__PURE__*/ React.createElement(List.Item, {
            key: i,
            description: text('projectUserNumber', {
                number: i + 1,
                email: null
            }),
            value: item.user.email
        });
    })) : /*#__PURE__*/ React.createElement(Loading, null)), /*#__PURE__*/ React.createElement(Modal.Footer, null, /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        onClick: function() {
            history.push(routes.fileManager.viewProject(projectId));
            onHide();
        }
    }, text('goToFileManager')))) : /*#__PURE__*/ React.createElement(Loading, null));
};
export default ProjectTrialMembersSuccessModal;
